import { Fragment, ReactElement } from 'react';
import ResearchMarriageDetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageDetailNotificationsCivilStatusShared scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchMarriageDetailNotificationsCivilStatusPage.displayName =
  'Research Marriage Detail Notifications CivilStatusPage component';

export default ResearchMarriageDetailNotificationsCivilStatusPage;
